import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'score-details-popup',
  templateUrl: 'score-details-popup.component.html',
  styleUrls: ['public-two-dimensional-ai-result-details.component.scss']
})
export class ScoreDetailsPopupComponent implements OnInit {
  initialized = false;

  @Input()
  score: number;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.initialized = true;
  }

  getGeneralScoreDescription()
  {
    if (this.score >= 90)
      return "Your score is Excellent! This means your running form is efficient and places you at a low risk of injury. While this is a strong result, there’s always room to refine your form so you can reach your peak potential. Focus on the specific areas flagged in your analysis and use corrective exercises to keep progressing and protecting your long - term health.";
    else if (this.score >= 80 && this.score < 90)
      return "Your score is Good. This suggests that your running form is reasonably healthy, though there are areas where improvement will help reduce injury risk and boost efficiency. By addressing these smaller issues with corrective exercises, you’ll strengthen your running mechanics, lower your risk, and move closer to your peak performance.";
    else if (this.score >= 60 && this.score < 80)
      return "Your score is Fair. This means your running form has some clear inefficiencies that may be limiting your performance and increasing your risk of injury.The good news is that these are highly correctable by addressing the flagged areas and practicing targeted exercises, you can run more comfortably, reduce your injury risk, and steadily move toward stronger, more efficient mechanics.";
    else
      return "Your score is Poor. This indicates that your running form is inefficient and puts you at a high risk of injury, but it also provides a clear roadmap for where to focus your energy. By working on the highlighted areas and prioritizing corrective exercises, you can make fast, meaningful progress toward safer and more effective running. With consistent effort, you’ll build a stronger foundation and unlock long-term performance gains.";
  }

  getGeneralScoreImage()
  {
    if (this.score >= 90)
      return "Score Meter Excellent.png";
    else if (this.score >= 80 && this.score < 90)
      return "Score Meter Good.png";
    else if (this.score >= 60 && this.score < 80)
      return "Score Meter Fair.png";
    else
      return "Score Meter Poor.png"; 
  }

  overrideScore(scoreLevel: string)
  {
    if (scoreLevel == 'G')
      return "E";
    else if (scoreLevel == 'GF')
      return "G";

    return scoreLevel;
  }
}
